<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <div class="form-contain">
    <a-spin :spinning="confirmLoading">
        <detail-list size="small">
          <detail-list-item :term="$t('命令类型')">{{commandName}}</detail-list-item>
          <detail-list-item :term="$t('命令状态')">{{reportStatusObj[model.status]?$t(reportStatusObj[model.status]):''}}</detail-list-item>
          <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
          <detail-list-item :term="$t('发送时间')">{{model.sendTime}}</detail-list-item>
          <detail-list-item :term="$t('回应时间')">{{model.receiveTime}}</detail-list-item>
          <detail-list-item :term="$t('创建时间')">{{model.createTime}}</detail-list-item>
          <!-- <detail-list-item term="更新时间">{{model.updateTime}}</detail-list-item> -->
        </detail-list>
      <a-form :colon="colon">
        <a-row :gutter="24">
          <a-col :span="24" class="descriptions">
            <a-descriptions v-if="model.cmd == 0" :title="$t('命令参数')" bordered size="small">
              <template v-for="(val,key) in formateCmdParamObj">
                <a-descriptions-item v-if="formateCmdParamObj[key]&&termPressParams[key]" :label="model.deviceType == 'PM'?$t(termPressParams[key]):$t(termWaterParams[key])" :key="key">
                  {{val}}
                </a-descriptions-item>
              </template>
            </a-descriptions>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
    </div>
  </j-modal>
</template>

<script>
  import { httpAction,getAction } from '@/api/manage'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import {dataFlagObj,reportStatusObj} from '@/utils/constants/protocolConstant'
  import {meterTypeObj} from '@/utils/constants/commonConstant'
  import {isUndefinedAndNull} from '@/utils/validate'

  const cmdList= {0: '终端参数配置'};
  const termPressParams = {
    'FH': '压力报警上限(MPa)',
    'FL': '压力报警下限(MPa)',
    'FF': '压力波动报警值(MPa)',
    'FB': '压力恢复报警差值(MPa)',
    'TH': '温度报警上限(℃)',
    'TL': '温度报警下限(℃)',
    'TF': '温度波动报警值(℃)',
    'TB': '温度恢复报警差值(℃)',
    'AT': '上报时间(分钟)',
    'CT': '采样时间(秒)',
    'BR': '电池电量复位'
  }

  const termWaterParams = {
    'FH': '液位报警上限(m)',
    'FL': '液位报警下限(m)',
    'FF': '液位波动报警值(m)',
    'FB': '液位恢复报警差值(m)',
    'TH': '液位报警上限(℃)',
    'TL': '液位报警下限(℃)',
    'TF': '温度波动报警值(℃)',
    'TB': '温度恢复报警差值(℃)',
    'AT': '上报时间(分钟)',
    'CT': '采样时间(*10秒)',
    'BR': '电池电量复位'
  }

  export default {
    name: "PartValveServiceQueueModal",
    components: {
      DetailList,
      DetailListItem
    },
    data () {
      return {
        meterTypeObj,
        cmdList,
        disableSubmit: false,
        visible: false,
        colon: false,
        model: {},
        reportStatusObj: reportStatusObj,
        confirmLoading: false,
        validatorRules:{
        },
        url: {
          add: "/model/partCommand/add",
          edit: "/model/partCommand/edit",
          queryCMDDetailById:"/jeecg-charge/part/partValveCommand/queryDetailCMDById"
        },
        commandNameList: dataFlagObj,
        termWaterParams,
        termPressParams,
        formateCmdParamObj: {}
      }
    },
    created () {
    },
    computed: {
        title() {
            return this.$t('操作')
        },
        commandName() {
            if(this.model.cmd) {
                const name = this.cmdList[this.model.cmd];
                return name ? this.$t(name) : this.$t('未知');
            }else{
              return this.$t("未知");
            }
        }
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        //this.queryCMDDetailById(record)
        this.model = Object.assign({}, record);
        this.visible = true;
        if(!isUndefinedAndNull(this.model.cmdParam)&&this.model.cmd == 0) {
          this.formateCmdParamObj = {...JSON.parse(this.model.cmdParam)}
        }else{
          if(this.model.cmdParam&&this.model.cmdParam!='') {
            this.formateCmdParamObj = JSON.parse(this.model.cmdParam)
          }
        }
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      },
      queryCMDDetailById(record) {
        this.model = {}
        console.log(record);
        let params = {}
        params.id = record.id;
        getAction(this.url.queryCMDDetailById, params).then((res) => {
          if(res.success){
            this.model = Object.assign({}, res.result);
          }
        }) 
      },
    }
  }
</script>

<style lang="less" scoped>
.form-contain{
  height: 60vh;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>